import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class JobApplicationService {
  constructor(private http: HttpClient) {}

  getJobApplications(filters: any = {}): Observable<any> {
    return this.http.get(`${environment.Server_URL}/job-applications`, {
      params: this.buildParams(filters),
    });
  }

  getApplicationsByJobId(jobId: any, filters: any = {}): Observable<any> {
    return this.http.get(`${environment.Server_URL}/jobs/${jobId}/applications`, {
      params: this.buildParams(filters),
    });
  }

  updateApplicationStatus(id: any, data: any): Observable<any> {
    return this.http.patch(`${environment.Server_URL}/job-applications/${id}/status`, data);
  }

  deleteJobApplication(id: any): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/job-applications/${id}`);
  }

  private buildParams(filters: any = {}): HttpParams {
    let params = new HttpParams();

    Object.keys(filters).forEach((key) => {
      const value = filters[key];

      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value);
      }
    });

    return params;
  }
}
